/**
 * /tenants/$slug/authentication/locations/new — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { CreateNamedLocationPage } from "@/features/named-locations/pages/create-named-location-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/authentication/locations/new",
)({
  component: CreateNamedLocationPage,
});
